<template>
  <span :class="activeStatus.classes">
    <CheckIcon v-if="status === 'done'" :class="activeStatus.iconClasses" />
    <StopCircleIcon v-if="status === 'warn'" :class="`${activeStatus.iconClasses}`" />
    {{ label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { CheckIcon, StopCircleIcon } from '@heroicons/vue/24/solid'

const props = withDefaults(defineProps<{ status: 'done' | 'warn' | 'error'; label?: string; height?: string }>(), {
  status: 'done',
  label: '',
  height: '25px',
})

const commonIconClasses = 'w-[20px] mr-2'
const statusIndicatorMap = {
  done: {
    label: 'done',
    classes: `inline-flex items-center  bg-green-100 text-green-800 text-xs font-large me-2 px-2 py-0.5 rounded dark:bg-gray-700 dark:text-green-400 border border-green-400 h-[${props?.height}]`,
    iconClasses: `${commonIconClasses}`,
  },
  warn: {
    label: 'warning',
    classes: `inline-flex items-center bg-yellow-100 text-yellow-800 text-xs font-large me-2 px-2 py-0.5 rounded dark:bg-gray-700 dark:text-yellow-300 border border-yellow-300 h-[${props?.height}]`,
    iconClasses: `${commonIconClasses}`,
  },
  error: {
    label: 'error',
    classes: `inline-flex items-center bg-red-100 text-red-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-red-400 border border-red-400 h-[${props?.height}]`,
    iconClasses: `${commonIconClasses}`,
  },
}

const activeStatus = computed(() => {
  return statusIndicatorMap[props?.status]
})
</script>
